module.exports = __webpack_public_path__ + "static/img/winter_jianjiePic.fe157ee3.png";